import cookies from 'js-cookie';

import { UserType } from '../types';

export const setUserTypeToCookie = (userType: UserType): void => {
  cookies.set('development-user-type', userType);
};
